import router, { navigate, replace, navigateAttemptedRoute } from "./lib/router-lib"

export { navigate, replace, navigateAttemptedRoute }

export default router
